import { DataState } from 'types/store/reducers/dataSources';

import { normalizeById } from 'store/utils';
import { Session } from 'types';
import { SessionActions } from 'types/store/actions/sessions';
import { SessionActionTypes } from 'types/store/actions/constants';

export const initialState: DataState<Session> = {
  data: {},
};

export default (
  state = initialState,
  action: SessionActions
): DataState<Session> => {
  switch (action.type) {
    case SessionActionTypes.RESET:
      return initialState;

    case SessionActionTypes.LIST_SUCCESS: {
      const { records } = action.payload;
      const normalizedData = normalizeById(records);
      return {
        ...state,
        data: { ...state.data, ...normalizedData },
      };
    }

    case SessionActionTypes.FETCH_SUCCESS: {
      const record = action.payload;
      return {
        ...state,
        data: { ...state.data, [record.id]: record },
      };
    }

    default:
      return state;
  }
};
